export const tabsInit = () => {
    if (document.body.classList.contains("home")) {
        const tabs = document.querySelectorAll(".inter__innerTabsTab");
        const pages = document.querySelectorAll(".inter__innerPagesPage");
        // console.log(tabs, pages)
        // Initially hide all content pages except the first one and set the 'active' class
        pages.forEach((page, index) => {
            if (index === 0) {
                page.classList.add("is-on");
                tabs[index].classList.add("is-on"); // Add the 'active' class to the first tab as well
            }
        });

        // Add click event to each tab
        tabs.forEach((tab, index) => {
            tab.addEventListener("click", () => {
                // Hide all content pages
                pages.forEach((page) => {
                    page.classList.remove("is-on"); // Remove the 'active' class from all content pages
                });

                // Display the content page corresponding to the clicked tab
                pages[index].classList.add("is-on"); // Add the 'active' class to the clicked content page

                // Remove the 'active' class from all tabs and add it to the clicked tab
                tabs.forEach((innerTab) => {
                    innerTab.classList.remove("is-on");
                });
                tab.classList.add("is-on");
            });
        });
    }
};

tabsInit();
